// @core/api/endpoints/subscription/create_product_bundle.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateProductBundleRequest,
  ProductBundleResponse,
} from '../../../types/subscription';

const BASE_PATH = '/subscription';

/**
 * Create a product bundle
 * Creates a new product bundle with specified products, pricing, and billing mode. Bundles can include required and optional products.
 */
export async function CreateProductBundle(
  data: CreateProductBundleRequest,
  options?: RequestOptions
): Promise<ProductBundleResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/bundles`;
  const requestOptions = options;
  return client.post<ProductBundleResponse>(requestPath, data, requestOptions);
}
